import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  inputLabel: {
    marginBottom: 10,
    fontSize: 16,
    color: '#000000',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  required: {
    color: '#ff5660',
  },
  helperText: {
    fontSize: 16,
    color: '#000000',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
}));
